import Popper from 'popper.js'
import _ from 'lodash'
import debugLog from '@/debug-log-script-name.js'
var debounce = require('debounce')

$(function() {
  let tooltipPopper
  const $dimmer = $('.dimmer')

  $('body').on('bless', function(e) {
    const $target = $(e.target),
      $inputs = $target.is('[data-tooltip]')
        ? $target
        : $target.find('[data-tooltip]')
    debugLog($inputs, 'tooltip.js') // DEBUG
    $inputs.on(
      'tooltip click focus',
      debounce(
        function(e) {
          const $el = $(this),
            $popper = $('#tooltip')
          tooltipPopper = new Popper($el[0], $popper[0], {
            placement: 'right',
            modifiers: {
              flip: {
                enabled: false,
              },
              offset: {
                offset: '0, -50px',
              },
            },
            onCreate: function(data) {
              const templateVars = {
                value: e.value ? e.value : $el.val(),
                name: $el.attr('name'),
              }

              if (e.title) {
                templateVars['title'] = e.title
              }

              const template = _.template(
                  window.templates[$el.attr('data-tooltip')],
                )(templateVars),
                $tooltip = $(data.instance.popper).html(template)

              $tooltip
                .on('click', '[data-dismiss="tooltip"]', function(e) {
                  $tooltip.removeClass('active').off()
                  data.instance.destroy()
                  $dimmer.removeClass('active')
                })
                .on('click', '[data-confirm="tooltip"]', function() {
                  var $toolTipInput = $tooltip.find(
                    '[name="' + $el.attr('name') + '"]',
                  )

                  $el.val($toolTipInput.val()).trigger({
                    type: 'change',
                    fromOnLoad: e.onload,
                    oldValue: templateVars.value,
                    preventAmounts: e.preventAmounts,
                  }) // Pass through additional properties

                  $tooltip.removeClass('active').off()
                  data.instance.destroy()
                  $dimmer.removeClass('active')
                })
                .on('keyup', function(e) {
                  if (e.which == 13) {
                    // Enter
                    $tooltip.find('[data-confirm="tooltip"]').trigger('click')
                    e.preventDefault()
                  }

                  if (e.which == 27) {
                    // Escape
                    $tooltip.find('[data-dismiss="tooltip"]').trigger('click')
                    e.preventDefault()
                  }
                })
                .addClass('active popper--tooltip')
                .trigger('bless')
                .find('input')
                .focus()
                .select()

              $dimmer.addClass('active')

              data.instance.update()
            },
            onUpdate: function(data) {},
          })

          return false
        },
        150,
        false,
      ),
    )

    $inputs
      .filter('[data-tooltip-onload="true"]')
      .trigger({ type: 'tooltip', onload: true }) // Trigger with extra parameter to indicate onload
  })

  $('body').on('click modal.show', function(e) {
    $('.popper--tooltip').each(function(i, el) {
      hideTooltip($(el), e)
    })
  })

  function hideTooltip($el, e) {
    if (
      !$el.is(e.target) &&
      $el.has(e.target).length === 0 &&
      $('.popover').has(e.target).length === 0
    ) {
      // $el.removeClass('active').off();
      $(tooltipPopper.popper)
        .removeClass('active')
        .off()
      tooltipPopper.destroy()
      $dimmer.removeClass('active')
    }
  }
})
